import Phaser from 'phaser';
import $ from 'jquery';
import { CST } from '../CST';
import { Score } from '../controller/score.js';

export default class Story_select extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.STORY_SELECT);
	}

	preload() {
		// Story selection button spritesheets — only needed when the story selection
		// screen is shown, so loaded here instead of the global preload
		this.load.spritesheet('forgetting-me-btn', 'assets/Buttons/forgettingme_button.png', {
			frameWidth: 316.5,
			frameHeight: 280,
		});
		this.load.spritesheet('games-with-grandpa-btn', 'assets/Buttons/gameswithgrandpa_button.png', {
			frameWidth: 316.5,
			frameHeight: 280,
		});
		this.load.spritesheet('helping-gran-btn', 'assets/Buttons/helpinggran_button.png', {
			frameWidth: 749.5,
			frameHeight: 660,
		});
		this.load.spritesheet('kept-in-the-loop-btn', 'assets/Buttons/keptintheloop_button.png', {
			frameWidth: 316.5,
			frameHeight: 280,
		});
		this.load.spritesheet('making-memories-btn', 'assets/Buttons/makingmemories_button.png', {
			frameWidth: 316.5,
			frameHeight: 279,
		});
		this.load.spritesheet('repetition-btn', 'assets/Buttons/repetition_button.png', {
			frameWidth: 316.5,
			frameHeight: 279,
		});
		this.load.spritesheet('visiting-grandpa-btn', 'assets/Buttons/visitinggrandpa_button.png', {
			frameWidth: 316.5,
			frameHeight: 279,
		});
	}

	create(data) {
		this.clickSound = this.sound.add('click-sound');

		this.bg = this.add.image(0, 0, 'select-story-bg').setOrigin(0);

		const cam = this.cameras.main;
		cam.setBounds(0, 0, 1500, 800); //Left, Top, X Limit, Y Limit
		cam.setZoom(1); //0.8
		cam.centerOn(0, 0); //1100, 800

		this.score = new Score(this);
		this.User_ID = data.User_ID;

		this.txt = this.add.text(
			this.cameras.main.width / 2 - 25,
			this.cameras.main.height / 2 - 350,
			'Klik pada kartu di meja untuk bermain!',
			CST.TEXTSTYLES.STORY_SELECT,
		);

		//843, 150
		let story1btn = this.add
			.sprite(1290, 500, 'forgetting-me-btn', 0)
			.setScale(0.4)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerover', () => {
				story1btn.setFrame(1);
			})
			.on('pointerout', () => {
				story1btn.setFrame(0);
			})
			.on('pointerdown', () => {
				this.clickSound.play();
				(this.scene.pause(),
					this.scene.launch(CST.SCENES.UISCENE, {
						User_ID: this.User_ID,
						story: 1,
					}));
			});

		let story2btn = this.add
			.sprite(970, 500, 'making-memories-btn', 0)
			.setScale(0.4)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerover', () => {
				story2btn.setFrame(1);
			})
			.on('pointerout', () => {
				story2btn.setFrame(0);
			})
			.on('pointerdown', () => {
				this.clickSound.play();
				(this.scene.pause(),
					this.scene.launch(CST.SCENES.UISCENE, {
						User_ID: this.User_ID,
						story: 2,
					}));
			});

		let story3btn = this.add
			.sprite(820, 500, 'visiting-grandpa-btn', 0)
			.setScale(0.4)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerover', () => {
				story3btn.setFrame(1);
			})
			.on('pointerout', () => {
				story3btn.setFrame(0);
			})
			.on('pointerdown', () => {
				this.clickSound.play();
				(this.scene.pause(),
					this.scene.launch(CST.SCENES.UISCENE, {
						User_ID: this.User_ID,
						story: 3,
					}));
			});

		let story4btn = this.add
			.sprite(660, 500, 'repetition-btn', 0)
			.setScale(0.4)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerover', () => {
				story4btn.setFrame(1);
			})
			.on('pointerout', () => {
				story4btn.setFrame(0);
			})
			.on('pointerdown', () => {
				this.clickSound.play();
				(this.scene.pause(),
					this.scene.launch(CST.SCENES.UISCENE, {
						User_ID: this.User_ID,
						story: 4,
					}));
			});

		let story5btn = this.add
			.sprite(1120, 500, 'games-with-grandpa-btn', 0)
			.setScale(0.4)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerover', () => {
				story5btn.setFrame(1);
			})
			.on('pointerout', () => {
				story5btn.setFrame(0);
			})
			.on('pointerdown', () => {
				this.clickSound.play();
				(this.scene.pause(),
					this.scene.launch(CST.SCENES.UISCENE, {
						User_ID: this.User_ID,
						story: 5,
					}));
			});

		let story6btn = this.add
			.sprite(515, 500, 'kept-in-the-loop-btn', 0)
			.setScale(0.4)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerover', () => {
				story6btn.setFrame(1);
			})
			.on('pointerout', () => {
				story6btn.setFrame(0);
			})
			.on('pointerdown', () => {
				this.clickSound.play();
				(this.scene.pause(),
					this.scene.launch(CST.SCENES.UISCENE, {
						User_ID: this.User_ID,
						story: 6,
					}));
			});

		//Story 7
		/*let story7btn = this.add.sprite(425, 170, 'helping-gran-btn', 0).setScale(0.2).setInteractive({
            useHandCursor: true
        }).on('pointerover', () => {
            story7btn.setFrame(1);
        }).on('pointerout', () => {
            story7btn.setFrame(0);
        }).on('pointerdown', () => {
            this.clickSound.play();
            this.scene.pause(), this.scene.launch(CST.SCENES.UISCENE, {
                User_ID: this.User_ID,
                story: 7 //7
            });
        });*/

		var story1complete = false;
		var story2complete = false;
		var story3complete = false;
		var story4complete = false;
		var story5complete = false;
		var story6complete = false;
		var story7complete = false;

		this.events.on('resume', (e, t) => {
			switch (t.story) {
				case 1:
					story1btn.destroy();
					story1complete = true;
					break;
				case 2:
					story2btn.destroy();
					story2complete = true;
					break;
				case 3:
					story3btn.destroy();
					story3complete = true;
					break;
				case 4:
					story4btn.destroy();
					story4complete = true;
					break;
				case 5:
					story5btn.destroy();
					story5complete = true;
					break;
				case 6:
					story6btn.destroy();
					story6complete = true;
					break;
				case 7:
					story7btn.destroy();
					story7complete = true;
					break;
			}

			if (
				story1complete === true ||
				story2complete === true ||
				story3complete === true ||
				story4complete === true ||
				story5complete === true ||
				story6complete === true ||
				story7complete === true
			) {
				this.bg.setTexture('select-story-finish-bg');
				this.end = this.add
					.image(this.cameras.main.width / 2 - 515, this.cameras.main.height / 2 + 200, 'end-btn')
					.setInteractive({ useHandCursor: true })
					.on('pointerdown', () => {
						sendScore(data, this.score);
						this.scene.stop(CST.SCENES.UISCENE);
						this.scene.start(CST.SCENES.ENDSCREEN, {
							User_ID: this.User_ID,
						});
					});
			}
		});
	}
}

function sendScore(data, score) {
	var userAnswer = {
		User_ID: data.User_ID,
		score: score.showPoints(),
	};

	//Sending JSON string to PHP file
	$.ajax({
		type: 'POST',
		// url: 'api/post-score-to-ddbb.php', // local
		url: 'website/post-score-to-ddbb.php', // live
		dataType: 'JSON',
		data: userAnswer,
	}).responseJSON;
}
